import { startTransition, useEffect, useState, type ReactNode } from "react"

import { resolveOperatorSession } from "@/features/operator/shared/operator-access"
import {
  OperatorShellSessionContext,
  type OperatorShellSessionContextValue,
} from "@/features/operator/shared/operator-shell-session-context"

export function OperatorShellSessionProvider({
  children,
}: {
  children: ReactNode
}) {
  const [state, setState] = useState<OperatorShellSessionContextValue>({
    status: "loading",
  })

  useEffect(() => {
    let isActive = true

    startTransition(() => {
      setState({
        status: "loading",
      })
    })

    void resolveOperatorSession()
      .then((session) => {
        if (!isActive) {
          return
        }

        startTransition(() => {
          setState({
            session,
            status: "ready",
          })
        })
      })
      .catch((error: unknown) => {
        if (!isActive) {
          return
        }

        startTransition(() => {
          setState({
            message:
              error instanceof Error
                ? error.message
                : "Unable to resolve the operator shell session.",
            status: "error",
          })
        })
      })

    return () => {
      isActive = false
    }
  }, [])

  return (
    <OperatorShellSessionContext.Provider value={state}>
      {children}
    </OperatorShellSessionContext.Provider>
  )
}
